import {
  FilterGroup,
  FilterInput,
  LogicalOperator,
} from '@/components/publicSearch/constants';

function isActiveFilter(filter: FilterInput) {
  return !!(
    filter.field &&
    (filter.operator || filter.value) &&
    String(filter.field).trim()
  );
}

export function normalizeFilter(filter: FilterInput): FilterInput | null {
  if (!isActiveFilter(filter)) return null;
  return {
    field: filter.field.trim(),
    operator: filter.operator ?? '',
    value: filter.value ?? '',
  };
}

/** Normalizes filter groups for URL sync; preserves blank placeholder-only groups. */
export function normalizePublicSearchFilterGroup(
  group: FilterGroup,
): FilterGroup | null {
  const rawFilters = group.filters ?? [];
  const filters = rawFilters
    .map(normalizeFilter)
    .filter((filter): filter is FilterInput => filter !== null);

  if (filters.length === 0 && rawFilters.length === 0) return null;

  return {
    filters:
      filters.length > 0 ? filters : [{ field: '', operator: '', value: '' }],
    logicalOperator:
      group.logicalOperator === LogicalOperator.and
        ? LogicalOperator.and
        : LogicalOperator.or,
  };
}
